import { render, staticRenderFns } from "./TipperIcon.vue?vue&type=template&id=4414c4f6&"
import script from "./TipperIcon.vue?vue&type=script&lang=js&"
export * from "./TipperIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports